import React from 'react';
import { useCreateAppTranslationMutation } from '../../graphql/mutations/createAppTranslation.generated';
import { IconButton } from '../../components/Button/Button';
import {
  AppTranslationAppType,
  RequestUploadUrlType,
} from '../../graphql/generatedTypes';
import { GetAppTranslationsDocument } from '../../graphql/queries/getAppTranslations.generated';
import { FormGroup, Input, Label } from 'reactstrap';
import { useOnUploadFileHook } from '../../hooks/useOnUploadFileHook';
import { FaPlus } from 'react-icons/all';

export function CreateAppTranslation({
  appType,
}: {
  appType: AppTranslationAppType;
}) {
  const [useCreateAppTranslation, { loading }] =
    useCreateAppTranslationMutation();
  const [name, setName] = React.useState<string>('');
  const [url, setUrl] = React.useState<string>('');

  const {
    getUrlForS3FileUploadOnFileInputChangeEvent,
    loading: uploadingFile,
  } = useOnUploadFileHook(RequestUploadUrlType.AppTranslation);

  async function addTranslation() {
    await useCreateAppTranslation({
      variables: {
        input: {
          name,
          url,
          app_type: appType,
        },
      },
      refetchQueries: [
        {
          query: GetAppTranslationsDocument,
          variables: {
            app_type: appType,
          },
        },
      ],
    });
  }

  async function onInputFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    const url = await getUrlForS3FileUploadOnFileInputChangeEvent(e);
    if (url) {
      setUrl(url);
    }
  }

  const appTypeDisplayName =
    appType === AppTranslationAppType.ConsumerApp
      ? 'consumer app'
      : 'partner app';
  return (
    <div>
      <h4>App new translation for {appTypeDisplayName}</h4>
      <FormGroup>
        <Label>Name</Label>
        <Input value={name} onChange={(e) => setName(e.target.value)} />
        <br />
        <Label>Translation JSON file</Label>
        <Input type="file" onChange={onInputFileChange} />
        {uploadingFile && <div>Uploading file...</div>}
      </FormGroup>
      <IconButton
        label={'Add translation for ' + appTypeDisplayName}
        onClick={addTranslation}
        icon={<FaPlus />}
        disabled={uploadingFile || loading || !url || !name}
      ></IconButton>
    </div>
  );
}
